module.exports = __webpack_public_path__ + "static/media/6.154d3d7a.png";